export default function MarkPilotSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#0F766E]">
            Support - MarkPilot Watermark Maker
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, FAQs, and contact information
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#0F766E]">Getting Started</h2>
          <ol className="list-decimal space-y-2 pl-6">
            <li>Open MarkPilot and tap <strong>Watermark Photos</strong>.</li>
            <li>Pick one or more photos from your gallery.</li>
            <li>
              Add a <strong>text watermark</strong> (your name, brand, or
              copyright line) or a <strong>logo watermark</strong> (a PNG with
              transparency works great).
            </li>
            <li>
              Drag to position it, adjust size, rotation, and opacity, or turn
              on <strong>tile mode</strong> to repeat the watermark across the
              whole photo.
            </li>
            <li>
              Tap <strong>Export</strong> — your photo is saved at full
              resolution with the watermark applied.
            </li>
          </ol>

          <h2 className="text-2xl font-bold text-[#0F766E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="font-bold">How do I watermark many photos at once?</h3>
              <p>
                Use <strong>Batch Watermark</strong> on the home screen. Pick
                your photos, choose or create a template, and export — the same
                watermark is applied to every photo in one pass. Positions are
                stored proportionally, so the watermark lands consistently even
                when photos have different sizes.
              </p>
            </div>
            <div>
              <h3 className="font-bold">Does the app reduce my photo quality?</h3>
              <p>
                No. MarkPilot exports at the photo&apos;s original resolution.
                JPG exports use a high quality setting, and PNG photos stay
                PNG.
              </p>
            </div>
            <div>
              <h3 className="font-bold">What file types are supported?</h3>
              <p>
                Photos: JPG, PNG, and WebP. Logo watermarks: PNG (transparency
                supported), JPG, and WebP.
              </p>
            </div>
            <div>
              <h3 className="font-bold">Does MarkPilot work offline?</h3>
              <p>
                Yes. Watermarking, templates, and export all run entirely on
                your device. An internet connection is only used for ads and
                anonymous diagnostics.
              </p>
            </div>
            <div>
              <h3 className="font-bold">Are my photos uploaded anywhere?</h3>
              <p>
                Never. Your photos and logos are processed locally and never
                leave your device.
              </p>
            </div>
            <div>
              <h3 className="font-bold">What are templates?</h3>
              <p>
                A template saves your complete watermark setup — text, logo,
                position, size, opacity, rotation, and tile settings — so you
                can re-apply it to future photos in one tap. Great for keeping
                a consistent brand mark on everything you post.
              </p>
            </div>
            <div>
              <h3 className="font-bold">How does the free version work?</h3>
              <p>
                The free version includes the full watermark editor and shows
                ads. An optional one-time Pro upgrade removes ads.
              </p>
            </div>
            <div>
              <h3 className="font-bold">The app is crashing — what should I do?</h3>
              <ul className="list-disc space-y-1 pl-6">
                <li>Make sure you are on the latest version from Google Play.</li>
                <li>Restart your device and try again.</li>
                <li>
                  Very large photos combined with low device memory can cause
                  issues — try exporting photos one at a time.
                </li>
                <li>
                  If it keeps happening, email us with your device model and
                  what you were doing — crash reports help us fix issues in
                  the next update.
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold">How do I restore my Pro purchase?</h3>
              <p>
                Install the app on your new device with the same Google
                account, open Settings, and tap the Pro tile — your purchase
                is restored automatically through Google Play.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#0F766E]">Contact Us</h2>
          <p>
            For help, feedback, or feature requests, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We read everything.
          </p>

          <p>
            See also the{" "}
            <a
              href="/apps/markpilot/privacy-policy"
              className="text-[#0F6BBF] underline"
            >
              MarkPilot Privacy Policy
            </a>
            .
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-sm text-[#8A93A2]">
          &copy; 2026 Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
